/**
 * Shared UI component for UI Card.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CardModule } from 'primeng/card';

import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-card',
  standalone: true,
  imports: [CardModule, UiLabelTranslatePipe],
  templateUrl: './ui-card.component.html',
  styleUrl: './ui-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiCardComponent {
  readonly title = input('');
}
